/* eslint-disable no-param-reassign */

export const setOfferManagementContent = (previousState, content) => {
  previousState.contentData = content;
};

export const setOfferManagementIsContentLoaded = (previousState, isContentLoaded) => {
  previousState.isContentLoaded = isContentLoaded;
};
